// Filename - components/landing/Offerings.js

import React, {Fragment, useEffect} from "react";
import { Container, Row, Col, Badge} from "react-bootstrap";
import { Link } from "react-router-dom";


export default function Offerings (){


    return (
      <Container fluid className="p-5">

         <Row className="mx-3 mt-3 mb-3">

            <Col className="col-12 col-md-6">
               <Container className="border border-dark">
                  <Row style={{backgroundColor: '#153574'}}>
                     <Col className="col-12 text-white text-center my-auto p-3">
                        <h4>Organizational Innovation</h4>
                     </Col>
                  </Row>
                  <Row className="m-1 p-1">
                     <p>
                        <span style={{color:'#153574'}}> Our corporate programs help companies create an innovation-focused, human-centered culture that increase employee engagement.</span>
                     </p>
                  </Row>
                  <Row>
                     <Col className="col-12 col-md-4 text-center">
                        <img 
                           src="images/hackingCreativity/HC-Assessment.png" 
                           width="80%"
                           alt="Hacking Creativity Assessment" 
                           fluid="true"
                            />
                     </Col>
                     <Col className="col-12 col-md-8 my-auto">
                        <h5><Badge bg="success">New</Badge> Culture Assessment</h5>
                     </Col>
                  </Row>
                  <Row className="m-1 mb-2">
                     <p className="small">
                        Our proprietary assessment can help you better understand your organization culture from a cognitive creativity perspective, and identify innovation bottlenecks. <Link to="/" >Learn more &raquo;</Link>
                     </p>
                  </Row>

                  <Row>
                     <Col className="col-12 col-md-4 text-center">
                        <img 
                           src="images/hackingCreativity/HC-Training.png" 
                           width="80%"
                           alt="Hacking Creativity Training" 
                           fluid="true"
                            />
                     </Col>
                     <Col className="col-12 col-md-8 my-auto">
                        <h5>Innovation First Strategy</h5>
                     </Col>
                  </Row>
                  <Row className="m-1 mb-2">
                     <p className="small">
                     <em>Innovation First </em> uses a first principles approach to designing your unique innovation-focused corporate culture. Our training programs help business leaders understand the fundamentals of cognitive creativity, emotional intelligence and teaming, and how to make their teams more innovative. <Link to="/" >Learn more &raquo;</Link>
                     </p>
                  </Row>
               </Container>
            </Col>

            <Col className="col-12 col-md-6">
               <Container className="border border-dark">
                  <Row style={{backgroundColor: '#808000'}}>
                     <Col className="col-2">
                        <img 
                           src="images/awards/EdTechDigestCoolTool2020.png" 
                           width="90%"
                           alt="Hacking Creativity Assessment" 
                           fluid="true"
                            
                           style={{transform: 'rotate(350deg)'}}/>

                     </Col>
                     <Col className="col-10 text-white text-center my-auto p-3">
                        <h4>K-12 Creativity Program</h4>
                     </Col>
                  </Row>
                  <Row className="m-1 p-1">
                     <p>
                        <span style={{color:'#808000'}}> MindAntix provides students with the opportunity to build creativity through access to fun, simple, and practical activities and exercises.</span>
                     </p>
                  </Row>
                  <Row>
                     <Col className="col-12 col-md-4 text-center">
                        <img 
                           src="images/challenges/Pose-a-Problem-small.png" 
                           width="80%"
                           alt="Cognitive Brainteaser" 
                           fluid="true"
                            />
                     </Col>
                     <Col className="col-12 col-md-8 my-auto">
                        <h5> Cognitive Brainteasers </h5>
                     </Col>
                  </Row>
                  <Row className="m-1 mb-2">
                     <p className="small">
                        Brainteasers build specific thinking styles—including associative thinking, analogical thinking and more—that have proven to improve creative thinking. They lay the foundation for learning different cognitive creativity techniques. <Link to="/" >Learn more &raquo;</Link>
                     </p>
                  </Row>

                  <Row>
                     <Col className="col-12 col-md-4 text-center">
                        <img 
                           src="images/challenges/How To Be An Inventor-small.png" 
                           width="80%"
                           alt="Project Based Learning" 
                           fluid="true"
                            />
                     </Col>
                     <Col className="col-12 col-md-8 my-auto">
                        <h5>Project Based Learning Modules</h5>
                     </Col>
                  </Row>
                  <Row className="m-1 mb-2">
                     <p className="small">
                        PBLs challenge students to apply these newly-learned strategies in real world scenarios. They provide a deeper learning experience and build an innovation mindset. Each module includes detailed lesson plans for teachers. <Link to="/" >Learn more &raquo;</Link>
                     </p>
                  </Row>
               </Container>
            </Col>

         </Row>

      </Container>
    )

}
